import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {TextField, Typography, withStyles} from '@material-ui/core';
import getObjectValue from 'libs/getObjectValue'
import Tr from 'translations/Translations';
import clsx from 'clsx';
import INPUT_TYPE from 'constants/INPUT_TYPE'
import toNumberType from "libs/toNumberType";

const style = theme => ({
    root: {
        position: 'relative',
    },
    limit: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        color: theme.palette.text.secondary,
    },
    error: {
        marginBottom: 10,
    }
})

function TextInput({
                       formikProps,
                       id,
                       label,
                       placeholder,
                       className,
                       noError,
                       noErrorSpace,
                       multiline,
                       disabled,
                       required,
                       endAdornment,
                       limit,
                       type = "text",
                       onChange = () => {
                       },
                       classes,
                       step,
                       onBlur = () => {
                       },
                       showErrorImmediately = false,
                       fullWidth = true,
	skipCheckTouched,
	...other
}) {
	const errorValue = getObjectValue(id, formikProps.errors, '')
	const touched = getObjectValue(id, formikProps.touched, !!skipCheckTouched)
	const value = getObjectValue(id, formikProps.values, '')
	const editable = getObjectValue('_editable', formikProps.values, true);

    const isError = !noError && (!!errorValue && Boolean(touched))
    const lettersLeft = limit - value.toString().length

    let _label = label;
    let _placeholder = placeholder;
    if (_label && required) _label += '*';
    if (_placeholder && required) _placeholder += '*';


    useEffect(() => {
        if (showErrorImmediately && lettersLeft < 0) {
            formikProps.setFieldTouched(id, true)
        }
        // eslint-disable-next-line
    }, [lettersLeft])

	const handleChange = (e) => {
		let value = e.target.value;
		switch (type) {
			case INPUT_TYPE.NUMBER_19:
			case INPUT_TYPE.NUMBER_19_WITH_NEGATIVE:
				const withMin = INPUT_TYPE.NUMBER_19_WITH_NEGATIVE === type;
				value = toNumberType(value, withMin ? /(?!(^([-]?)\d|[.,]|^[-]))\D/ : undefined);
				let valueSplit = value.split('.')
				if(valueSplit.length > 2) {
					valueSplit = valueSplit.slice(0, 2)
				}

				if (valueSplit.length > 1) {
					valueSplit[0] = valueSplit[0].slice(0, withMin && value.startsWith("-") ? 14 : 13)
					valueSplit[1] = valueSplit[1].slice(0, 2);
				} else {
					valueSplit[0] = valueSplit[0].slice(0, withMin && value.startsWith("-") ? 14 : 13)
				}
				value = valueSplit.join('.');
				break;
			case INPUT_TYPE.NUMBER_POSITIVE_AMOUNT:
				value = toNumberType(value);
				let valueSplitAmount = value.split('.')
				if(valueSplitAmount.length > 2) {
					valueSplit = valueSplit.slice(0, 2)
				}

				if (valueSplitAmount.length > 1) {
					valueSplitAmount[0] = valueSplitAmount[0].slice(0, 17)
					valueSplitAmount[1] = valueSplitAmount[1].slice(0, 10);
				} else {
					valueSplitAmount[0] = valueSplitAmount[0].slice(0, 17)
				}
				value = valueSplitAmount.join('.');
				break;
			case INPUT_TYPE.INTEGER_POSITIVE_AMOUNT:
				value = toNumberType(value, /\D/);
				break;
			case INPUT_TYPE.NUMBER_DECIMAL:
				if (value !== "-") {

					value = toNumberType(value, /(?!(^([-]?)\d|[.,]))\D/);
					const valueSplit1 = value.split('.')
					if (valueSplit1.length > 1) {
						valueSplit1[1] = valueSplit1[1].slice(0, 10);
						valueSplit1[0] = valueSplit1[0].slice(0, 17)
					} else {
						valueSplit1[0] = valueSplit1[0].slice(0, 17)
					}
					value = valueSplit1.filter((x, i) => i < 2).join('.');
				}
				break;
			case INPUT_TYPE.PHONE:
				value = toNumberType(value, /(?!(^([+]?)[ ]*\d|[ ]|^[+]))\D/);
				break;
			default:
				break;
		}

        onChange(value);
        if (type === 'number' || type === 'text') formikProps.handleChange(e)
        else {
            formikProps.setFieldValue(id, value)
            formikProps.setFieldTouched(id, true)
        }
    }

    const handleBlur = (e) => {
        onBlur(e)
        formikProps.handleBlur(e)
    }

	const inputType = ((type) => {
		switch (type) {
			case INPUT_TYPE.NUMBER_19:
			case INPUT_TYPE.NUMBER_19_WITH_NEGATIVE:
			case INPUT_TYPE.NUMBER_POSITIVE_AMOUNT: return 'text';
			default: return type;
		}
	})(type)

    const formatValue = () => {
        let v = '' + value;
        if (type !== "text") v = v.replace(/\./g, ',')
        return v;
    }

    return (
        <div
            className={clsx({[classes.error]: isError}, classes.root)}
        >
            <TextField
                {...other}

                className={className}
                type={inputType}
                label={_label}
                name={id}
                onChange={handleChange}
                onBlur={handleBlur}
                value={formatValue()}
                error={isError}
                helperText={noError ? undefined : isError ? errorValue : noErrorSpace ? undefined : ' '}
                placeholder={_placeholder}
                fullWidth={fullWidth}
                multiline={multiline}
                disabled={disabled || !editable}
                InputProps={{
                    endAdornment,
                }}
                maxRows={limit}
                // eslint-disable-next-line
                inputProps={{
                    step: step,
                    "data-id": id
                }}
            />
            {limit &&
                <Typography
                    variant='caption'
                    className={classes.limit}
                >
                    {Tr('characters_left', {number: lettersLeft < 0 ? 0 : lettersLeft})}
                </Typography>
            }
        </div>
    )
}

TextInput.propTypes = {
    formikProps: PropTypes.object,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    noError: PropTypes.bool,
}

TextInput.defaultProps = {
    noError: false,
}

export default withStyles(style)(TextInput)
